import React from 'react';
import classNames from 'classnames';
import { get } from 'lodash';
import Highlighter from 'react-highlight-words';
import { string, bool, func, number, shape, node } from 'prop-types';
import { BASE_CLASS } from './constants';

import './index.scss';

const SelectOption = ({
    label = '',
    isFocused = false,
    isDisabled = false,
    innerProps,
    selectProps = {},
    data,
    innerRef
}) => {
    const shouldHighlight = get(data, 'highlightSearch', true);

    return (
        <div ref={innerRef} className={classNames(
            BASE_CLASS,
            'co-text-dark',
            {
                focused: isFocused,
                disabled: isDisabled
            }
        )} {...innerProps}>
            {
                shouldHighlight ?
                    <Highlighter searchWords={[selectProps.inputValue]}
                        autoEscape
                        highlightClassName="orca-combobox-option-highlight"
                        textToHighlight={label}/>
                    : label
            }
        </div>
    );
};

SelectOption.displayName = 'SelectOption';

SelectOption.propTypes = {
    /**
     * Label to be displayed
     */
    label: string.isRequired,
    /**
     * Whether the option is focused
     */
    isFocused: bool,
    /**
     * Whether the option is disabled
     */
    isDisabled: bool,
    /**
     * The object passed in as the option
     */
    data: shape({
        highlightSearch: bool
    }),
    /**
     * React-select inner props
     */
    innerProps: shape({
        id: string,
        key: string,
        onClick: func,
        onMouseOver: func,
        tabIndex: number
    }),
    /**
     * React-select select props
     */
    selectProps: shape({
        inputValue: string
    }),
    innerRef: node
};

export default SelectOption;
